import { useContext } from 'react'

import { AddActionDialog } from '@pages/EntityCreateOrEdit'

import { CATEGORIES, ENTITY_TYPES_REQUEST } from '@constants'

import { PageContext } from '../../TooltipCreateOrEdit'

export const TooltipAddActionDialog = () => {
  const {
    handleCloseAddActionDialog,
    handleChangeAction,
    addActionDialogData,
    id,
    isUpdateActionProcessing,
  } = useContext(PageContext)

  if (!addActionDialogData) {
    return null
  }

  return (
    <AddActionDialog
      isDisableActionEventsFiltering
      showDialog
      actionEventsCategoryCode={CATEGORIES.BINDING_TOOLTIP_EVENTS_ACTIONS}
      actionTable={addActionDialogData.actionTable}
      bindingValuesAction={addActionDialogData.bindingValuesAction}
      columns={[]}
      createAction={handleChangeAction}
      currentRow={addActionDialogData.currentRow}
      editAction={handleChangeAction}
      isActionLoading={isUpdateActionProcessing}
      modalType={addActionDialogData.modalType}
      objectCode={addActionDialogData.objectCode}
      variablesConfig={{
        entityType: ENTITY_TYPES_REQUEST.TOOLTIP,
        entityId: id,
      }}
      onCloseModal={handleCloseAddActionDialog}
    />
  )
}
